import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import {
  Button,
  Modal,
  Tooltip,
} from 'antd';

import { Icon } from '@anna/anna-ws-ui';
import { history } from '../../utils/history';

import {
  requestCSVActions,
  requestCSVCheckStatusActions,
} from '../../services/downloadCSVService/actions';
import {
  requestZipActions,
  requestZipCheckStatusActions,
} from '../../services/downloadZipService/actions';
import { gaSendUserEvent, gaEventName } from '../../utils/analytics';

import styles from './styles.module.css';

class BottomPanel extends Component {
  componentDidUpdate() {
    const {
      csvRequestId, csvLoading, zipLoading, zipRequestId, actions,
    } = this.props;

    if (zipLoading && zipRequestId) {
      setTimeout(actions.requestDownloadZIPCheckStatus, 1000);
    }

    if (csvLoading && csvRequestId) {
      setTimeout(actions.requestDownloadCSVCheckStatus, 1000);
    }
  }

  renderXeroButton = () => (
    <Button
      type="primary"
      onClick={() => {
        Modal.info({
          title: 'Coming soon',
          content: (
            <div>
              <p>
                Here you can export data to
                {' '}
                <a
                  href="https://www.xero.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Xero
                </a>
              </p>

            </div>
          ),
          onOk() {
          },
        });
      }}
    >
      Export to Xero
    </Button>
  );

  requestDownloadCSVHandler = (format) => {
    const { actions } = this.props;
    actions.requestDownloadCSV(format);
    gaSendUserEvent(`${gaEventName.clickDownloadTransactionsCSV} (${format})`);
  };

  requestDownloadZIPHandler = () => {
    const { actions } = this.props;
    actions.requestDownloadZIP();
    gaSendUserEvent(gaEventName.clickDownloadFilesZip);
  };

  changeXeroMappings = () => {
    history.push('/company/xero');
  };

  render() {
    const {
      csvLoading, csvFormat, zipLoading, account, xeroAccounts,
    } = this.props;

    if (!account) {
      return null;
    }

    const showCsvDownload = account.source === 'anna';

    const showEditXeroButton = xeroAccounts && xeroAccounts.length > 0;

    return (
      <div className={styles.BottomPanel}>
        {showCsvDownload && (
          <div>
            <Button
              type="default"
              icon="download"
              loading={csvLoading && csvFormat === 'freeagent'}
              onClick={() => this.requestDownloadCSVHandler('freeagent')}
            >
              Download FreeAgent CSV
            </Button>
            <Tooltip
              title="Download a csv with all your transactions from the selected account within a selected timeframe only."
              placement="right"
            >
              <Icon name="ic_info" className={styles.InfoIcon} />
            </Tooltip>
          </div>
        )}
        {showCsvDownload && (
          <div>
            <Button
              type="default"
              icon="download"
              loading={csvLoading && csvFormat === 'quickbooks'}
              onClick={() => this.requestDownloadCSVHandler('quickbooks')}
            >
              Download QuickBooks CSV
            </Button>
            <Tooltip
              title="Download a csv with all your transactions from the selected account within a selected timeframe only."
              placement="right"
            >
              <Icon name="ic_info" className={styles.InfoIcon} />
            </Tooltip>
          </div>
        )}
        <div>
          <Button
            type="default"
            icon="download"
            loading={zipLoading}
            onClick={this.requestDownloadZIPHandler}
          >
            Download files
          </Button>
          <Tooltip
            title="Download all the attachments from the selected account within a selected timeframe only."
            placement="right"
          >
            <Icon name="ic_info" className={styles.InfoIcon} />
          </Tooltip>
        </div>
        {showEditXeroButton && (
          <div>
            <Button
              type="default"
              icon="edit"
              onClick={this.changeXeroMappings}
            >
              Edit Xero
            </Button>
          </div>
        )}
      </div>
    );
  }
}

BottomPanel.propTypes = {
  actions: PropTypes.shape({
    requestDownloadCSV: PropTypes.func.isRequired,
    requestDownloadCSVCheckStatus: PropTypes.func.isRequired,
    requestDownloadZIP: PropTypes.func.isRequired,
    requestDownloadZIPCheckStatus: PropTypes.func.isRequired,
  }).isRequired,
  zipRequestId: PropTypes.string.isRequired,
  zipLoading: PropTypes.bool.isRequired,
  csvRequestId: PropTypes.string.isRequired,
  csvLoading: PropTypes.bool.isRequired,
  csvFormat: PropTypes.string.isRequired,
  account: PropTypes.shape({
    source: PropTypes.string.isRequired,
  }).isRequired,
  xeroAccounts: PropTypes.arrayOf(PropTypes.shape({})),
};

BottomPanel.defaultProps = {
  xeroAccounts: [],
};

const mapStateToProps = ({
  downloadTransactionsCSVService,
  downloadZipService,
  accountService,
  xeroService,
}) => ({
  zipRequestId: downloadZipService.requestId,
  zipLoading: downloadZipService.loading,
  csvRequestId: downloadTransactionsCSVService.requestId,
  csvLoading: downloadTransactionsCSVService.loading,
  csvFormat: downloadTransactionsCSVService.format,
  account: accountService.account,
  xeroAccounts: xeroService.xeroAccounts,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    requestDownloadCSV: requestCSVActions.common,
    requestDownloadCSVCheckStatus: requestCSVCheckStatusActions.common,
    requestDownloadZIP: requestZipActions.common,
    requestDownloadZIPCheckStatus: requestZipCheckStatusActions.common,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BottomPanel);
